import React from 'react';
import { colors, fonts } from '../tokens';

/**
 * BenefitCard – einheitliche Vorteils-Karte (Icon + Titel + Beschreibung).
 * Höhe & Padding fix, Abstände dazwischen kommen vom Parent-Grid.
 */
export const BenefitCard = ({ icon: Icon, accentColor, title, description }) => (
  <div
    style={{
      border: `1px solid ${colors.border}`,
      borderRadius: '12px',
      padding: '24px 18px',
      background: colors.bgCard,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minHeight: '245px',
      maxHeight: '245px',
    }}
  >
    <div
      style={{
        width: '56px',
        height: '56px',
        background: accentColor,
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px',
        flexShrink: 0,
      }}
    >
      <Icon size={26} color="white" strokeWidth={2} />
    </div>
    <h3 style={{ fontFamily: fonts.display, fontSize: '12px', fontWeight: 700, color: colors.navy, marginBottom: '10px', lineHeight: 1.3, flexShrink: 0 }}>{title}</h3>
    <p
      className="proposal-body"
      style={{
        fontSize: '9.5px',
        lineHeight: 1.65,
        color: colors.slateMid,
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 8,
        WebkitBoxOrient: 'vertical',
      }}
    >
      {description}
    </p>
  </div>
);
